import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitContact = (payload) =>
  api.post("/contact", payload).then((r) => r.data);

export const subscribeNewsletter = (email) =>
  api.post("/newsletter", { email }).then((r) => r.data);

export const fetchSubmissions = (adminKey) =>
  api
    .get("/admin/submissions", { headers: { "x-admin-key": adminKey } })
    .then((r) => r.data);
